import { Button, Checkbox, DataSource, HorizontalSpacer, Label, Layout, Location, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRecOrderRates extends Layout {
    buttonEstimateFuelSurcharge: Button;
    buttonExpandCharges: Button;
    buttonExpandTaxes: Button;
    buttonRate: Button;
    checkboxLockMiles: Checkbox;
    chevronSpacer3: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    labelAdditionalCharges: Label;
    labelAutoRated: Label;
    labelFreightCharge: Label;
    labelTaxCharge: Label;
    labelTaxesHeader: Label;
    labelTotalCharge: Label;
    panelAllocationControllingParty: Panel;
    panelChevron3: Panel;
    panelExpandCharges: Panel;
    panelFreightCharge: Panel;
    panelOtherChargeTable: Panel;
    panelOtherCharges: Panel;
    panelOtherChargesHeader2: Panel;
    panelOtherChargesHeader: Panel;
    panelRateTotals: Panel;
    panelRates: Panel;
    panelRatesHeader: Panel;
    panelRecOrderExciseTaxTotal: Panel;
    panelRecOrderFreightCharge: Panel;
    panelRecOrderOtherCharges: Panel;
    panelRecOrderTotalCharges: Panel;
    panelRecOrderTotalWithTaxes: Panel;
    panelTaxTable: Panel;
    panelTaxes: Panel;
    panelTaxesContent: Panel;
    panelTaxesHeader: Panel;
    panelTaxesHeaderTitle: Panel;
    sourceExcisetaxChargeRec: DataSource;
    sourceOrderOtherChargeRec: DataSource;
    sourceRecurringOrder: DataSource;
    switchExciseDisableUpdate: Switch;
    switchTaxableOrder: Switch;
    tableOtherCharges: Table;
    tableTax: Table;
    textboxBillDistance: Textbox;
    textboxCollectionMethod: Textbox;
    textboxCtrlParty: Location;
    textboxCurrencyType: Textbox;
    textboxFreightCharge2: Textbox;
    textboxFreightCharge: Textbox;
    textboxOtherchargetotal: Textbox;
    textboxPieces: Textbox;
    textboxRate: Textbox;
    textboxRateExpiration: Textbox;
    textboxRateMinWeight: Textbox;
    textboxRateType: Textbox;
    textboxRateUnitDesc: Textbox;
    textboxRateUnits: Textbox;
    textboxRecOrderExciseTaxTotal: Textbox;
    textboxRecOrderTotalWithTax: Textbox;
    textboxSegAllocCode: Textbox;
    textboxTotalCharge: Textbox;
    textboxWeight: Textbox;
}
